import React, { useRef, useState, useEffect } from 'react'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'

interface TruncatedStringWithTooltipProps {
    children: string
    width?: number | string
    typographyProps?: React.ComponentProps<typeof Typography>
    styles?: React.CSSProperties
    onClick?: React.MouseEventHandler<HTMLSpanElement>
}

export const TruncatedStringWithTooltip: React.FC<
    TruncatedStringWithTooltipProps
> = ({ children, width = '100%', typographyProps, styles, onClick }) => {
    const textRef = useRef<HTMLSpanElement>(null)
    const [isTruncated, setIsTruncated] = useState(false)

    useEffect(() => {
        const el = textRef.current
        if (el) {
            setIsTruncated(el.scrollWidth > el.clientWidth)
        }
    }, [children, width])

    return (
        <Tooltip
            title={isTruncated ? children : ''}
            disableHoverListener={!isTruncated}
        >
            <Typography
                {...typographyProps}
                onClick={onClick}
                component="span"
                ref={textRef}
                sx={{
                    width,
                    display: 'inline-block',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    verticalAlign: 'bottom',
                    cursor: 'pointer',
                    ...styles,
                }}
            >
                {children}
            </Typography>
        </Tooltip>
    )
}
